import { api } from './../../api.js';
//import api_routes from './../../api_routes.js';

import axios from 'axios';

const state = {
	
}

const getters = {

}

const mutations = {

}

const actions = {
	getNotificationManagement : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/notification-management', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});		
	},
	getNotificationManagementDetail : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/notification-management/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	editNotificationManagement : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.patch('admin/notification-management/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/NotificationManagementModule.js